<div class="eb-added-to-cart-dialog" [cxFocus]="focusConfig" (esc)="dismissModal('Escape pressed')">
  <div class="eb-added-to-cart-container">
    <!-- Modal Header -->
    <ng-container *ngIf="loaded$ | async; else loading">
      <div class="cx-dialog-header modal-header">
        <div class="cx-dialog-title modal-title">
          {{
            (addedEntryWasMerged$ | async)
              ? ('addToCart.itemsIncrementedInYourCart' | cxTranslate)
              : ('addToCart.itemsAddedToYourCart' | cxTranslate)
          }}
        </div>
        <button
          type="button"
          class="close"
          [attr.aria-label]="'common.close' | cxTranslate"
          (click)="dismissModal('Cross click')"
        >
          <span aria-hidden="true">
            <cx-icon [type]="iconTypes.CLOSE"></cx-icon>
          </span>
        </button>
      </div>
      <!-- used for max order limit reached -->
      <div class="additional-info-section">
        <cx-global-message></cx-global-message>
      </div>
      <!-- Modal Body -->
      <div class="cx-dialog-body modal-body" *ngIf="entry$ | async as entry">
        <div class="cx-dialog-row row">
          <div class="cx-dialog-item col-12">
            <eb-cart-item-header></eb-cart-item-header>
            <eb-cart-item
              [item]="entry"
              [compact]="false"
              [showAvailability]="false"
              [quantityControl]="getQuantityControl() | async"
              [promotionLocation]="promotionLocation"
              [cartPopUp]="true"
              [pushMatomoEvents]="true"
            ></eb-cart-item>
          </div>
          <!-- Separator -->
          <div class="cx-dialog-separator col-sm-12 d-xs-block d-sm-block d-md-none"></div>
          <!-- Total container -->
          <div class="cx-dialog-actions col-12" *ngIf="cart$ | async as cart">
            <!-- Actions -->
            <div class="cx-dialog-buttons">
              <a
                [class.disabled]="form.dirty"
                [routerLink]="{ cxRoute: 'checkout' } | cxUrl"
                class="btn btn-secondary"
                (click)="dismissModal('Proceed To Checkout click')"
                >{{ 'addToCart.proceedToCheckout' | cxTranslate }}</a
              >
              <a
                [class.disabled]="form.dirty"
                [routerLink]="{ cxRoute: 'cart' } | cxUrl"
                (click)="dismissModal('View Cart click')"
                class="btn btn-primary"
                autofocus
                >{{ 'addToCart.viewCart' | cxTranslate }}</a
              >
            </div>
          </div>
        </div>
      </div>
    </ng-container>
    <ng-template #loading>
      <div class="cx-dialog-header modal-header">
        <div class="cx-dialog-title modal-title">
          {{ 'addToCart.updatingCart' | cxTranslate }}
        </div>
        <button
          type="button"
          class="close"
          [attr.aria-label]="'common.close' | cxTranslate"
          (click)="dismissModal('Cross click')"
        >
          <span aria-hidden="true">
            <cx-icon [type]="iconTypes.CLOSE"></cx-icon>
          </span>
        </button>
      </div>
      <!-- Modal Body -->
      <div class="cx-dialog-body modal-body">
        <div class="cx-dialog-row">
          <div class="col-sm-12">
            <eb-spinner></eb-spinner>
          </div>
        </div>
      </div>
    </ng-template>
  </div>
</div>
